module.exports = __webpack_public_path__ + "img/img-service-02@2x.e34be5c8.jpg";